import { Button, ButtonProps, CircularProgress, Icon } from "@mui/material";
import React, { useState } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface ExtendedButtonProps<TPromise = void> extends ButtonProps {
    promise?: (event: React.MouseEvent) => Promise<TPromise>
}

const ExtendedButton = ({ promise, startIcon, color, onClick, ...rest }: ExtendedButtonProps) => {

    const [status, setStatus] = useState<'idle' | 'loading' | 'error' | 'success'>('idle')

    const onClickHandler = (event: React.MouseEvent) => {
        if (promise) {
            setStatus('loading')
            promise(event)
                .then(() => setStatus('success'))
                .catch(() => setStatus('error'))
        }
    }

    return (
        <Button
            disabled={status === 'loading'}
            startIcon={
                status === 'loading' ? <CircularProgress size={24} /> :
                    status === 'error' ? <ErrorIcon /> :
                        status === 'success' ? <CheckCircleIcon /> :
                            startIcon
            }
            color={
                status === 'error' ? 'error' :
                    status === 'success' ? 'success' :
                        color
            }
            onClick={promise ? onClickHandler : onClick}
            {...rest}
        />
    )
}

export default ExtendedButton
